import { cn } from "@/lib/cn";

interface AuroraOverlayProps {
  active: boolean;
  "data-testid"?: string;
}

/**
 * Ambient aurora gradient overlay shown on frames being actively worked on.
 * Three overlapping radial gradients with slow shift animation.
 * Must be rendered as a direct child of the outermost frame div (with overflow-hidden),
 * NOT inside the scrollable content container.
 */
export function AuroraOverlay({
  active,
  "data-testid": testId = "aurora-overlay",
}: AuroraOverlayProps) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 z-10 overflow-hidden rounded-lg transition-opacity duration-[800ms]",
        active ? "opacity-100" : "opacity-0",
      )}
      data-testid={testId}
      aria-hidden="true"
    >
      <div className="aurora-shift absolute -inset-1/2 h-[200%] w-[200%]" />
    </div>
  );
}
